import React from "react";
import {observer} from "mobx-react";
import {useServices} from "../../../../hooks/use-services.hook";
import styled from "styled-components";
import {
    SwapStationsButtonBaseBox,
    SwapStationsChevronIconWrapperBox
} from "../boxes/swap-stations-button.base-boxes";
import {ChevronUpIcon} from "../../../../assets/svg/chevron-up.icon";
import {ChevronDownIcon} from "../../../../assets/svg/chevron-down.icon";

const SwapStationsButtonBox = styled(SwapStationsButtonBaseBox)`
    flex-direction: row;
    right: ${props => props.theme.spacing.spacing12};
    top: 50%;
    transform: translateY(-50%);
    padding: 6px 11px;
`


export const SearchMaskSwapStationsButtonSmallScreenComponent: React.FC = observer(() => {
    const services = useServices();
    return (
        <SwapStationsButtonBox onClick={() => services.flightSearch.switchStations()}>
            <SwapStationsChevronIconWrapperBox>
                <ChevronUpIcon/>
            </SwapStationsChevronIconWrapperBox>
            <SwapStationsChevronIconWrapperBox>
                <ChevronDownIcon/>
            </SwapStationsChevronIconWrapperBox>
        </SwapStationsButtonBox>
    );
})